import React, { useState, useEffect } from 'react';
import { HiDownload } from "react-icons/hi";
import { getActivityReports } from '../../api/activityReportService';

export default function AnnualReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      setLoading(true);
      const response = await getActivityReports();
      if (response.isSuccess && response.data) {
        setReports(response.data);
      }
    } catch (error) {
      console.error('Error fetching reports:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="annual-reports">
      <div className="container py-5 xs-py-3">
        <h1 className="page-title">Faaliyet Raporları</h1>
        <div className="reports-container">
          {loading ? (
            <div className="loading">Yükleniyor...</div>
          ) : reports.length > 0 ? (
            reports.map((report) => (
              <div key={report.guid} className="report-item">
                <span className="report-title">{report.name}</span>
                <a href={report.file} className="pdf-link" target="_blank" rel="noopener noreferrer">
                  PDF <HiDownload />
                </a>
              </div>
            ))
          ) : (
            <div className="no-reports">Henüz faaliyet raporu bulunmamaktadır.</div>
          )}
        </div>
      </div>
    </div>
  );
}
